import * as React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Modal, Input, Alert, DatePicker } from 'antd';
import { FormComponentProps } from '@ant-design/compatible/lib/form/Form';
import { connect } from 'react-redux';
import moment from 'moment';
import { RangePickerProps } from 'antd/es/date-picker';

const FormItem = Form.Item;

interface DeferWorkOrderModalProps {
	onSubmit: any;
	onCancel: any;
	visible: boolean;
	createErrors: any;
	updateErrors: any;
	creating: boolean;
	updating: boolean;
	workOrderId: number;
	currentUser: any;
	formTitle: any;
	formText: any;
	buttonLoading: boolean;
}

interface DeferWorkOrderProps extends FormComponentProps {
	onSubmit: any;
	onCancel: any;
	visible: boolean;
	createErrors: any;
	updateErrors: any;
	creating: boolean;
	updating: boolean;
	workOrderId: number;
	currentUser: any;
	formTitle: any;
	formText: any;
	buttonLoading: boolean;
}

class DeferWorkOrderModal extends React.Component<DeferWorkOrderModalProps, any> {
	render() {
		const {
			visible,
			onCancel,
			onSubmit,
			form,
			currentUser,
			workOrderId,
			createErrors,
			updateErrors,
			formTitle,
			formText,
			buttonLoading,
		} = this.props;
		const { getFieldDecorator } = form;
		const dateFormat = 'dddd, MMM D, YYYY';
		getFieldDecorator('workOrderId', { initialValue: workOrderId });
		const disabledDate: RangePickerProps['disabledDate'] = (current) => {
			// Can not select days before today and today
			return current && current < moment().endOf('day');
		};
		return (
			<Modal
				visible={visible}
				width={600}
				title={formTitle}
				okText={formText}
				onCancel={onCancel}
				onOk={onSubmit}
				closable={false}
				confirmLoading={buttonLoading}
			>
				<Form layout="vertical" className="deferWorkForm">
					{createErrors.length > 0 ? (
						<FormItem>
							<Alert message={createErrors.join(' ')} type="error" />
						</FormItem>
					) : null}
					{updateErrors.length > 0 ? (
						<FormItem>
							<Alert message={updateErrors.join(' ')} type="error" />
						</FormItem>
					) : null}
					<FormItem label="Defer Until" format={dateFormat} required={false}>
						{form.getFieldDecorator('deferDate', {
							initialValue: undefined,
						})(<DatePicker disabledDate={disabledDate} />)}
					</FormItem>
				</Form>
			</Modal>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	visible: ownProps.visible,
	onCancel: ownProps.onCancel,
	onSubmit: ownProps.onSubmit,
	createErrors: state.buyer_contacts.createErrors,
	updateErrors: state.buyer_contacts.updateErrors,
	creating: state.buyer_contacts.creating,
	updating: state.buyer_contacts.updating,
	currentUser: state.session.currentUser,
	formTitle: ownProps.formTitle,
	formText: ownProps.formText,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Form.create<DeferWorkOrderProps>()(DeferWorkOrderModal));
